import { useTranslation } from 'react-i18next'

import { useNotification } from '../../../../../../hooks'
import { addMockApplicant } from '../../../../../RentalPortalApplicant'
import { getApplicantFormPayload } from '../../RentalPortalApplicantForm.utils'

import {
  getApplicantFormFailureErrorKey,
  getApplicantFormSubmitErrorText,
  getIsApplicantFormConflictError,
  setApplicantFormSubmitError,
} from './useApplicantFormSubmit.utils'

export function useApplicantFormSubmit({ onSuccess }) {
  const { t } = useTranslation()

  const { handleAddErrorNotification } = useNotification()

  async function handleSubmit(values, { setErrors, setSubmitting }) {
    let record = null

    try {
      const { data } = await addMockApplicant(getApplicantFormPayload(values))

      record = data
    } catch (error) {
      const hasFieldErrors = setApplicantFormSubmitError({
        error,
        errorText: getApplicantFormSubmitErrorText({ error, t }),
        setErrors,
        setSubmitting,
      })

      if (!getIsApplicantFormConflictError(error) && !hasFieldErrors) {
        handleAddErrorNotification(getApplicantFormFailureErrorKey(error))
      }

      return
    }

    onSuccess?.(record)
  }

  return { handleSubmit }
}
